// extracted by mini-css-extract-plugin
module.exports = {"instruction-header":"guides_instruction-header__FBi6Z","instruction-subheader":"guides_instruction-subheader__9Md2b"};